import React, { FC } from "react";

import type { SvgIconConstituentValues } from "./typed";

interface SvgProps {
  fill?: string;
}

export const ArrowDownSolidIcon: FC<SvgIconConstituentValues & SvgProps> = ({
  fill,
  ...props
}) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    {...props}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7 10.0781L12 15.0781L17 10.0781H7Z" fill={fill} />
  </svg>
);

ArrowDownSolidIcon.defaultProps = {
  fill: "#FF4F00",
};
